import React, { useState } from 'react';
import DOMPurify from 'dompurify';
import { getS3 } from "../../utils/Download";
const FinalApprovalPopup = ({
  certificate,
  onClose,
  onSubmit,
}) => {
    
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (status) => {
    if (status === 'Rejected' && !comments.trim()) {
      setError('Please provide comments for rejection');
      return;
    }

    setIsSubmitting(true);
    setError('');

    let actionType;
    if (certificate.pass_reattempt_status.String.toLowerCase() === 'reattempt') {
      actionType = 'final_ph_approval';
    } else {
      actionType = 'final_ph_approval';
    }

    const payload = {
      action_type: actionType,
      request_id: certificate.request_id,
      emp_id: certificate.emp_id,
      approval_status: status,
      comments: comments.trim()
    };

    // Call onSubmit and handle the response
    const success = onSubmit(payload); // Wait for the result

    setIsSubmitting(false); // Stop submitting regardless of success

    if (success) {
      onClose(); // Close the popup only on success
    }
  };

  return (
    <div className="modal fade show d-block"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(2px)'
      }}
    >
      <div className="modal-dialog certification-modal approval-modal-width">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title" id="staticBackdropLabel">
              Certification Approval - {certificate?.emp_name}
            </h6>
            <button type="button" className="btn-close font-12"
              data-bs-dismiss="modal" aria-label="Close"
              onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-8 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Certification Name
                </label>
                <div className="d-flex justify-content-start align-items-center">
                  <p className="font-12 semibold-text">{certificate?.certificate_name}</p>
                  {certificate?.client_dependency.Bool && (
                    <span className="client-badge ms-2">Client</span>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Provider
                </label>
                <p className="font-12 semibold-text">{certificate?.provider}</p>
              </div>

              <div className="col-md-8 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Status
                </label>
                <p className="font-12 semibold-text">{certificate?.pass_reattempt_status.String}</p>
              </div>

              <div className="col-md-4 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  {certificate?.pass_reattempt_status.String.toLowerCase() === "failed" ? "Attachments" : "Certificate"}
                </label>
                <a
                  onClick={async (e) => {
                    e.preventDefault();
                    window.open(await getS3(certificate?.certificate_url.String), "_blank");
                  }}
                  className="d-flex align-items-center bg-white p-2 border border-light-subtle rounded-3 shadow-sm text-decoration-none font-10 semibold-text text-dark"
                  target="_blank" rel="noopener noreferrer">
                  <img src="/Images/pdf-icon.svg" alt="pdf-icon" className="me-1" />
                  {certificate?.certificate_name}
                </a>
              </div>

              <div className="col-md-12 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Comments
                </label>
                <textarea
                  className={`form-control font-12 comment-box ${error ? 'border-danger' : ''}`}
                  placeholder="Type your comments here..."
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
                {error && (
                  <label className="font-11 regular-text text-danger">
                    {error}
                  </label>
                )}
              </div>
            </div>
          </div>

          <div className="modal-footer border-0">
            <div className="col-md-12 d-flex justify-content-end">
              <button
                className="btn negative-btn me-2 font-12 semibold-text"
                onClick={() => handleSubmit('Rejected')}
                disabled={isSubmitting}
              >
                Reject
              </button>
              <button
                className="btn succes-btn font-12 semibold-text"
                onClick={() => handleSubmit('Approved')}
                disabled={isSubmitting}
              >
                Approve
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalApprovalPopup;